import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthGuard } from "../services/auth.guard";

import { App2ColLayout } from "src/layouts/2-col/2-col.layout";

import {
  PERMISSIONS,
  ROLE_RESOURCE_PERMISSIONS,
} from "src/constants/constants";
import { RestrictedAuthGuard } from "src/services/restricted.auth.guard";
import { OrgMemberListComponent } from "src/pages/ranking/org-member-list/org-member-list.component";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "login",
  },
  {
    path: "admin",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "admin",
    component: App2ColLayout,
    children: [
      {
        path: "error",
        canActivate: [AuthGuard],
        data: { title: "Permission Error" },
        loadComponent: () =>
          import("../pages/error-permission/error-permission.component").then(
            (m) => m.ErrorPermissionComponent
          ),
      },
      {
        path: "dashboard",
        canActivate: [AuthGuard],
        data: {
          title: "Dashboard",
          identifierName: "",
          permissions: [ROLE_RESOURCE_PERMISSIONS.DASHBOARD],
        },
        children: [
          {
            path: "",
            loadComponent: () =>
              import(
                "../pages/welcome-dashboard/welcome-dashboard.component"
              ).then((m) => m.WelcomeDashboardComponent),
          },
          {
            path: "org-members",
            component: OrgMemberListComponent,
            data: {
              title: "",
            },
          },
        ],
      },
      {
        path: "reset-password",
        canActivate: [AuthGuard],
        data: {
          title: "Reset Password",
        },
        loadComponent: () =>
          import("../pages/reset-password/reset-password.component").then(
            (m) => m.ResetPasswordComponent
          ),
      },
      {
        path: "user",
        canActivate: [AuthGuard],
        data: {
          title: "Users",
          permissions: [ROLE_RESOURCE_PERMISSIONS.USERS],
        },
        loadChildren: () =>
          import("../pages/users/user.module").then((m) => m.UserModule),
      },
      {
        path: "datasets",
        canActivate: [AuthGuard],
        data: {
          title: "Datasets",
          permissions: [
            ROLE_RESOURCE_PERMISSIONS.ARTEFACTS,
            ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS,
          ],
        },
        loadChildren: () =>
          import("../pages/datasets/dataset.module").then(
            (m) => m.DatasetModule
          ),
      },
      {
        path: "artefact",
        canActivate: [AuthGuard],
        data: {
          title: "Artefact Approvals",
          permissions: [
            ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS,
            ROLE_RESOURCE_PERMISSIONS.ARTEFACTS,
            ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS_VERSION,
          ],
        },
        loadChildren: () =>
          import("../pages/artefact/artefact.module").then(
            (m) => m.ArtefactModule
          ),
      },
      {
        path: "master-data",
        canActivate: [AuthGuard],
        data: {
          title: "Code Masters",
          permissions: [ROLE_RESOURCE_PERMISSIONS.MASTER_DATA],
        },
        loadChildren: () =>
          import("../pages/master-data/master-data.module").then(
            (m) => m.MasterDataModule
          ),
      },
      {
        path: "toolkits",
        data: {
          title: "Toolkits",
        },
        loadChildren: () =>
          import("../pages/toolkits/toolkits.module").then(
            (m) => m.ToolkitsModuleTsModule
          ),
      },
      {
        path: "use-case",
        canActivate: [AuthGuard],
        data: {
          title: "Use Case",
          permissions: [
            ROLE_RESOURCE_PERMISSIONS.ARTEFACTS,
            ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS,
          ],
        },
        loadChildren: () =>
          import("../pages/usecase/usecase.module").then(
            (m) => m.UsecaseModule
          ),
      },
      {
        path: "content/maintenance",
        canActivate: [AuthGuard],
        data: {
          title: "Maintenance",
          permissions: [ROLE_RESOURCE_PERMISSIONS.MAINTENANCE],
        },
        loadChildren: () =>
          import("../pages/maintenance/maintenance.module").then(
            (m) => m.MaintenanceModule
          ),
      },
      {
        path: "resources",
        canActivate: [AuthGuard],
        data: {
          title: "Resources",
          permissions: [ROLE_RESOURCE_PERMISSIONS.TUTORIALS],
        },
        loadChildren: () =>
          import("../pages/resources/resources.module").then(
            (m) => m.ResourcesModule
          ),
      },
      {
        path: "organisation",
        canActivate: [AuthGuard],
        data: {
          title: "Organisation",
          permissions: [ROLE_RESOURCE_PERMISSIONS.ORGANISATION],
        },
        loadChildren: () =>
          import("../pages/organisation/organisation.module").then(
            (m) => m.OrganisationModule
          ),
      },
      {
        path: "banners",
        canActivate: [AuthGuard],
        data: {
          title: "Banners",
          permissions: [ROLE_RESOURCE_PERMISSIONS.BANNERS],
        },
        loadChildren: () =>
          import("../pages/banners/banners.module").then(
            (m) => m.BannersModule
          ),
      },
      {
        path: "promotional-emails",
        canActivate: [AuthGuard],
        data: {
          title: "Promotional Emails",
          permissions: [ROLE_RESOURCE_PERMISSIONS.PROMOTIONAL_EMAILS]
        },
        loadChildren: () =>
          import("../pages/promotional-emails/promotional-emails.module").then(
            (m) => m.PromotionalEmailModules
          )
      },
      // {
      //   path: "system-params",
      //   canActivate: [AuthGuard],
      //   data: {
      //     title: "System Parameters",
      //     permissions: [ROLE_RESOURCE_PERMISSIONS.SYSTEM_PARAMS],
      //   },
      //   loadChildren: () =>
      //     import("../pages/system-params/system-params.module").then(
      //       (m) => m.SystemParamsModule
      //     ),
      // },
      {
        path: "models",
        canActivate: [AuthGuard],
        data: {
          title: "Models",
          permissions: [
            ROLE_RESOURCE_PERMISSIONS.ARTEFACTS,
            ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS,
          ],
        },
        loadChildren: () =>
          import("../pages/models/model.module").then((m) => m.ModelsModule),
      },

      {
        path: "manage-grievances",
        data: {
          title: "Manage Grievances",
          permissions: [ROLE_RESOURCE_PERMISSIONS.MANAGE_GRIEVANCES],
        },
        loadChildren: () =>
          import("../pages/manage-grievances/manage-grievances.module").then(
            (m) => m.ManageGrievancesModule
          ),
      },
      {
        path: "feedback-management",
        canActivate: [AuthGuard],
        data: {
          title: "Feedback Management",
          permissions: [ROLE_RESOURCE_PERMISSIONS.FEEDBACK_MANAGEMENT],
        },
        loadChildren: () =>
          import(
            "../pages/feedback-management/feedback-management.module"
          ).then((m) => m.FeedbackManagementModule),
      },
      {
        path: "org-approval",
        canActivate: [AuthGuard],
        data: {
          title: "Org Approval",
          permissions: [ROLE_RESOURCE_PERMISSIONS.ORG_APPROVAL],
        },
        loadChildren: () =>
          import("../pages/org-approval/org-approval.module").then(
            (m) => m.OrgApprovalModule
          ),
      },
      {
        path: "content",
        canActivate: [AuthGuard],
        data: { title: "Content" },
        loadChildren: () =>
          import("../pages/content/content.module").then(
            (m) => m.ContentModule
          ),
      },
      {
        path: "roleManagement",
        canActivate: [AuthGuard],
        data: { title: "Content" },
        loadChildren: () =>
          import(
            "../pages/permission-management/permissionManagement.module"
          ).then((m) => m.PermissionManagementModule),
      },
      {
        path: "teams/manage-roles",
        canActivate: [AuthGuard],
        data: {
          title: "Manage Team Roles",
          permissions: [ROLE_RESOURCE_PERMISSIONS.MANAGE_TEAM_ROLES],
        },
        loadChildren: () =>
          import("../pages/manage-team-roles/manage-team-role.module").then(
            (m) => m.ManageTeamRoleModule
          ),
      },
      {
        path: "my-profile",
        canActivate: [AuthGuard],
        loadComponent: () =>
          import("../pages/my-profile/my-profile.component").then(
            (m) => m.MyProfileComponent
          ),
      },
      {
        path: "notebook",
        canActivate: [AuthGuard],
        data: {
          title: "Notebook Approvals",
          permissions: [ROLE_RESOURCE_PERMISSIONS.COMPUTE_NOTEBOOK],
        },
        loadChildren: () =>
          import("../pages/notebook/notebook.module").then(
            (m) => m.NotebookModule
          ),
      },
      {
        path: "competitions",
        canActivate: [AuthGuard],
        data: {
          title: "Competitions",
          permissions: [ROLE_RESOURCE_PERMISSIONS.COMPETITIONS],
        },
        loadChildren: () =>
          import("../pages/competition/competition.module").then(
            (m) => m.CompetitionModule
          ),
      },
    ],
  },
  {
    path: "login",
    canActivate: [RestrictedAuthGuard],
    loadChildren: () =>
      import("../pages/login-page/login.module").then((m) => m.LoginModule),
  },
  { path: "**", redirectTo: "login", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
